import React from "react";
import { InlineMath } from "react-katex";
import FractionInput, {
  formatLatexPreview,
} from "../../../../components/inputs/FractionInput";

function randInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function formatMath2(v) {
  return Number(v).toFixed(2);
}

function pickData() {
  // Trudniejszy wariant: różna liczba miejsc po przecinku.
  // Jedna liczba ma 1 miejsce po przecinku, druga 2 miejsca.
  // Wymuszamy przynajmniej jedno przeniesienie.
  for (let i = 0; i < 700; i += 1) {
    const firstOneDecimal = Math.random() < 0.5;

    const aUnits = firstOneDecimal
      ? randInt(100, 999) * 10 // x,x
      : randInt(1000, 9999); // x,xx
    const bUnits = firstOneDecimal
      ? randInt(1000, 9999) // x,xx
      : randInt(100, 999) * 10; // x,x

    // W "jednomiejscowej" liczbie unikamy x.0,
    // a w "dwumiejscowej" liczbie unikamy końcowego 0.
    if (firstOneDecimal && Math.floor(aUnits / 10) % 10 === 0) continue;
    if (!firstOneDecimal && Math.floor(bUnits / 10) % 10 === 0) continue;
    if (!firstOneDecimal && aUnits % 10 === 0) continue;
    if (firstOneDecimal && bUnits % 10 === 0) continue;

    const h1 = aUnits % 10;
    const h2 = bUnits % 10;
    const d1 = Math.floor(aUnits / 10) % 10;
    const d2 = Math.floor(bUnits / 10) % 10;
    const j1 = Math.floor(aUnits / 100) % 10;
    const j2 = Math.floor(bUnits / 100) % 10;
    const dz1 = Math.floor(aUnits / 1000) % 10;
    const dz2 = Math.floor(bUnits / 1000) % 10;

    const c1 = h1 + h2 >= 10;
    const c2 = d1 + d2 + (c1 ? 1 : 0) >= 10;
    const c3 = j1 + j2 + (c2 ? 1 : 0) >= 10;
    const c4 = dz1 + dz2 + (c3 ? 1 : 0) >= 10;

    if (!(c1 || c2 || c3 || c4)) continue;

    const aDisplay = firstOneDecimal ? formatMath2(aUnits / 100).replace(/0$/, "") : formatMath2(aUnits / 100);
    const bDisplay = firstOneDecimal ? formatMath2(bUnits / 100) : formatMath2(bUnits / 100).replace(/0$/, "");

    return {
      aUnits,
      bUnits,
      resultUnits: aUnits + bUnits,
      a: aUnits / 100,
      b: bUnits / 100,
      result: (aUnits + bUnits) / 100,
      aDisplay,
      bDisplay,
    };
  }

  return {
    aUnits: 7857,
    bUnits: 3430,
    resultUnits: 11287,
    a: 78.57,
    b: 34.3,
    result: 112.87,
    aDisplay: "78.57",
    bDisplay: "34.3",
  };
}

function placeName(colFromRight) {
  if (colFromRight === 0) return "setnych";
  if (colFromRight === 1) return "dziesiętnych";
  if (colFromRight === 2) return "jedności";
  if (colFromRight === 3) return "dziesiątek";
  if (colFromRight === 4) return "setek";
  return `${colFromRight - 1}. rzędu`;
}

function digitsOf(units, cols) {
  const arr = Array(cols).fill(0);
  for (let i = 0; i < cols; i += 1) {
    arr[i] = Math.floor(units / 10 ** (cols - 1 - i)) % 10;
  }
  return arr;
}

function analyzeAddition(aUnits, bUnits) {
  const aIntLen = String(Math.floor(aUnits / 100)).length;
  const bIntLen = String(Math.floor(bUnits / 100)).length;
  const intCols = Math.max(aIntLen, bIntLen);
  const cols = intCols + 2;

  const aDigits = Array(cols + 1).fill("");
  const bDigits = Array(cols + 1).fill("");
  const resultDigits = Array(cols + 1).fill("");
  const carryDigits = Array(cols + 1).fill("");

  const aBase = digitsOf(aUnits, cols);
  const bBase = digitsOf(bUnits, cols);
  for (let i = 0; i < cols; i += 1) {
    aDigits[i + 1] = String(aBase[i]);
    bDigits[i + 1] = String(bBase[i]);
  }

  const detailLines = [];
  const steps = [];
  let carryIn = 0;

  for (let c = cols; c >= 1; c -= 1) {
    const colFromRight = cols - c;
    const a = Number(aDigits[c] || 0);
    const b = Number(bDigits[c] || 0);
    const sum = a + b + carryIn;

    if (c > 1) {
      const digit = sum % 10;
      const carryOut = Math.floor(sum / 10);
      resultDigits[c] = String(digit);

      detailLines.push({
        place: placeName(colFromRight),
        expr: carryIn ? `${a}+${b}+${carryIn}` : `${a}+${b}`,
        sum,
        digit,
        carryOut,
      });

      if (carryOut > 0) carryDigits[c - 1] = String(carryOut);

      steps.push({
        aDigits: [...aDigits],
        bDigits: [...bDigits],
        carryDigits: [...carryDigits],
        resultDigits: [...resultDigits],
        highlightResult: [c],
        highlightCarry: carryOut > 0 ? [c - 1] : [],
        showComma: false,
        intCols,
      });

      carryIn = carryOut;
    } else {
      if (sum >= 10) {
        resultDigits[0] = String(Math.floor(sum / 10));
        resultDigits[1] = String(sum % 10);
        detailLines.push({
          place: placeName(colFromRight),
          expr: carryIn ? `${a}+${b}+${carryIn}` : `${a}+${b}`,
          sum,
          digit: sum,
          carryOut: 0,
        });
        steps.push({
          aDigits: [...aDigits],
          bDigits: [...bDigits],
          carryDigits: [...carryDigits],
          resultDigits: [...resultDigits],
          highlightResult: [0, 1],
          highlightCarry: [],
          showComma: false,
          intCols,
        });
      } else {
        resultDigits[1] = String(sum);
        detailLines.push({
          place: placeName(colFromRight),
          expr: carryIn ? `${a}+${b}+${carryIn}` : `${a}+${b}`,
          sum,
          digit: sum,
          carryOut: 0,
        });
        steps.push({
          aDigits: [...aDigits],
          bDigits: [...bDigits],
          carryDigits: [...carryDigits],
          resultDigits: [...resultDigits],
          highlightResult: [1],
          highlightCarry: [],
          showComma: false,
          intCols,
        });
      }
    }
  }

  steps.push({
    aDigits: [...aDigits],
    bDigits: [...bDigits],
    carryDigits: [...carryDigits],
    resultDigits: [...resultDigits],
    highlightResult: [],
    highlightCarry: [],
    showComma: true,
    intCols,
  });

  return { detailLines, steps };
}

const ORANGE = "#f59e0b";

function Row({
  sign,
  digits,
  showComma,
  intCols,
  highlightIndices = [],
  small = false,
  reserveComma = false,
}) {
  const commaAfter = intCols;
  const merged = [];

  for (let i = 0; i < digits.length; i += 1) {
    merged.push({ type: "digit", v: digits[i], idx: i });
    if (reserveComma && i === commaAfter) {
      merged.push({ type: "comma", visible: showComma });
    }
  }

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: `1ch repeat(${merged.length}, 1ch)`,
        columnGap: "0.08em",
        alignItems: "end",
        whiteSpace: "nowrap",
      }}
    >
      <span>{sign || "\u00A0"}</span>
      {merged.map((x, i) => {
        if (x.type === "comma") {
          return (
            <span key={`c-${i}`} style={x.visible ? undefined : { opacity: 0 }}>
              ,
            </span>
          );
        }

        const hl = highlightIndices.includes(x.idx);
        return (
          <span
            key={`d-${x.idx}`}
            style={
              hl
                ? { color: ORANGE, fontWeight: 700, fontSize: small ? "0.72em" : "1em" }
                : small
                  ? { fontSize: "0.72em" }
                  : undefined
            }
          >
            {x.v === "" ? "\u00A0" : x.v}
          </span>
        );
      })}
    </div>
  );
}

function MiniBoard({ step }) {
  return (
    <div
      style={{
        padding: "10px 14px",
        border: "1px solid var(--color-border)",
        borderRadius: 8,
        background: "transparent",
        width: "fit-content",
      }}
    >
      <div
        style={{
          fontFamily: "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
          lineHeight: 1.2,
          display: "inline-block",
        }}
      >
        <Row
          sign=""
          digits={step.carryDigits}
          showComma={false}
          intCols={step.intCols}
          highlightIndices={step.highlightCarry}
          small
          reserveComma
        />
        <Row sign="" digits={step.aDigits} showComma intCols={step.intCols} reserveComma />
        <Row sign="+" digits={step.bDigits} showComma intCols={step.intCols} reserveComma />
        <div style={{ margin: "2px 0", borderTop: "1px solid var(--color-text)", width: "100%" }} />
        <Row
          sign=""
          digits={step.resultDigits}
          showComma={step.showComma}
          intCols={step.intCols}
          highlightIndices={step.highlightResult}
          reserveComma
        />
      </div>
    </div>
  );
}

export function generateTask() {
  return {
    type: "DecimalAdditionVariableTask",
    data: pickData(),
  };
}

export function renderTask({ data }) {
  return (
    <div style={{ textAlign: "left" }}>
      <p>Oblicz: <InlineMath math={`${data.aDisplay} + ${data.bDisplay}`} /></p>
    </div>
  );
}

export function renderInput(_task, userAnswer, onChange, disabled) {
  return (
    <FractionInput
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
      label="wynik"
      placeholder="np. 12,35 lub 12.35"
    />
  );
}

export function checkAnswer(task, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object") return false;
  const parsed = userAnswer.parsed;
  if (parsed == null || !Number.isFinite(parsed)) return false;
  return Math.abs(parsed - task.data.result) < 1e-9;
}

export function renderAnswer({ data }) {
  return <InlineMath math={formatMath2(data.result).replace(".", "{,}")} />;
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }
  return <InlineMath math={formatLatexPreview(userAnswer.raw)} />;
}

export function renderExplanation({ data }) {
  const written = analyzeAddition(data.aUnits, data.bUnits);

  return (
    <div style={{ textAlign: "left" }}>
      <p>
        <strong>Krok 1:</strong> Ustawiamy liczby pionowo (przecinek pod przecinkiem).
      </p>
      <p>Dopisujemy brakujące zera na końcu liczby z mniejszą liczbą miejsc po przecinku.</p>

      <p>
        <strong>Krok 2:</strong> Dodajemy od prawej strony. Jeśli w kolumnie wychodzi co najmniej 10, zapisujemy
        jedności, a 1 przenosimy do kolejnej kolumny.
      </p>

      <ul style={{ marginTop: 6, marginBottom: 8 }}>
        {written.detailLines.map((line, idx) => (
          <li key={idx}>
            {line.place}: <InlineMath math={`${line.expr}=${line.sum}`} />{" "}
            {line.carryOut > 0 ? (
              <>
                {"\u2192"} zapisujemy <InlineMath math={`${line.digit}`} />, przenosimy{" "}
                <InlineMath math={`${line.carryOut}`} />
              </>
            ) : (
              <>
                {"\u2192"} zapisujemy <InlineMath math={`${line.digit}`} />
              </>
            )}
          </li>
        ))}
        <li>na końcu dopisujemy przecinek w wyniku dokładnie pod przecinkiem składników</li>
      </ul>

      <div
        style={{
          marginTop: 8,
          marginBottom: 10,
          padding: 10,
          border: "1px solid var(--color-border)",
          borderRadius: 8,
          background: "transparent",
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            gap: 8,
          }}
        >
          {written.steps.map((step, idx) => (
            <React.Fragment key={idx}>
              <MiniBoard step={step} />
              {idx < written.steps.length - 1 ? (
                <div style={{ fontSize: "1.2rem", fontWeight: 700, color: "var(--color-text)" }}>{"\u2192"}</div>
              ) : null}
            </React.Fragment>
          ))}
        </div>
      </div>

      <p>
        <strong>Wynik:</strong> <InlineMath math={formatMath2(data.result).replace(".", "{,}")} />
      </p>
    </div>
  );
}

